/**
 * Next.js 15 client instrumentation hook.
 * Runs once on the client before React hydrates.
 *
 * `agent-react-devtools/connect` opens a WebSocket to localhost:8097. That is
 * useful when an engineer is actively running the React DevTools daemon, but
 * noisy in normal local validator runs and makes the Network tab look like
 * realtime is reconnecting. Keep it opt-in so localnet mirrors devnet socket
 * behavior unless inspection is explicitly requested.
 */
import { env } from '@/lib/config/env';
import { isTelemetryActive } from '@/lib/telemetry';
import { initSoftNavigationTracking } from '@/lib/telemetry/soft-navigation';
import { initWebVitals } from '@/lib/telemetry/web-vitals';

if (env.NEXT_PUBLIC_AGENT_REACT_DEVTOOLS === '1') {
  void import('agent-react-devtools/connect');
}

// Real-user performance telemetry. Gated to live Vercel deploys (the
// telemetry-active gate); a no-op in local dev and CI. Registers the five
// Core Web Vitals listeners and patches the History API to measure
// soft-navigation (client route-change) latency.
if (isTelemetryActive()) {
  initWebVitals();
  initSoftNavigationTracking();
}
